import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {
  data: any;

  constructor(
    public config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    this.data = this.config.data;
    console.log('Order Details:', this.data);
  }

  getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'status-pending';
      case 'approved':
        return 'status-approved';
      case 'rejected':
        return 'status-rejected';
      case 'completed':
        return 'status-completed';
      case 'processing':
        return 'status-processing';
      default:
        return 'status-default';
    }
  }

  getTotalQuantity(): number {
    if (!this.data?.order?.items) return 0;
    return this.data.order.items.reduce((total: number, item: any) => total + (item.quantity || 0), 0);
  }
}
